import { LocaleHelperService } from '@app/services/locale-helper.service';

const MONTH_FALLBACKS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function getMonthOptions(localeHelper: LocaleHelperService): { label: string; value: number }[] {
  return MONTH_FALLBACKS.map((fallback, i) => ({
    label: localeHelper.translateWithFallback(`Common.month_${i + 1}`, fallback),
    value: i + 1,
  }));
}

export function getYearOptions(fromYear = 2020): { label: string; value: number }[] {
  const current = new Date().getFullYear();
  return Array.from({ length: current - fromYear + 1 }, (_, i) => {
    const year = current - i;
    return { label: year.toString(), value: year };
  });
}

export function formatFileNameTimestamp(date: Date = new Date()): string {
  const pad = (value: number) => value.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` + `_${pad(date.getHours())}-${pad(date.getMinutes())}`;
}
